<script>

export default {
    props: ['company'],
    data() {
        return {
            loading: false,
            errors: {},
            data: null,
            success: false,
        }
    },

    methods: {
        sendRequest() {
            this.loading = true;
            axios.post('/companies/' + this.company.id + '/withdrawal-settlements').then(response => {
                this.success = true;
                this.close();
            }).catch(error => {
            }).finally(() => {
                this.loading = false;
            })
        },
        close() {
            this.$emit('close', {settled: this.success});
        }
    }
};
</script>

<template>
    <section>
        <div class="modal is-active">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ $t('withdrawal_requests.labels.settle_requests') }}</p>
                    <button class="delete" aria-label="close" @click="close"></button>
                </header>
                <div class="modal-card-body">

                    <div>
                        <p class="mb-4">{{ $t('withdrawal_requests.fields.withdrawals_token_amount.name') }}: <strong>{{ company.withdrawals_token_amount }}</strong></p>
                        <p class="mb-4">{{ $t('companies.fields.name.name') }}: <strong>{{ company.name }}</strong></p>
                        <p>{{ $t('companies.fields.bank_account_number.name') }}: <strong>{{ company.user.bank_account_number }}</strong></p>
                    </div>

                </div>
                <footer class="modal-card-foot">
                    <div class="buttons">
                        <b-button @click="sendRequest()"
                                v-if="!success"
                                :disabled="loading || success"
                                :loading="loading"
                                type="is-success">
                            {{ $t('actions.send') }}
                        </b-button>
                        <b-button @click="close" v-if="!success">
                            {{ $t('actions.cancel') }}
                        </b-button>
                    </div>
                </footer>
            </div>
        </div>
    </section>
</template>
<style scoped>
.modal-card {
    min-height: 300px;
}
</style>
